import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToolPreautorisationService } from '../../../tool-preautorisation/tool-preautorisation.service';

export enum ResultatQuitter {
  Oui,
  Non
}

@Component({
  selector: 'app-dialog-quitter-page',
  templateUrl: './dialog-quitter-page.component.html',
  styleUrls: ['./dialog-quitter-page.component.scss'],
  standalone: false
})
export class DialogQuitterPageComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogQuitterPageComponent>,
    private readonly _toolPreautorisationService: ToolPreautorisationService
  ) {}

  confirm() {
    this._toolPreautorisationService.resetPreautorisation();
    this.dialogRef.close(ResultatQuitter.Oui);
  }

  close() {
    this.dialogRef.close();
  }
}
